import React, { Component } from 'react'
import PropTypes from 'prop-types'
import TextBlock from './TextBlock'
import TextBlockPreview from './TextBlockPreview'

export default class RichTextEditor extends Component {
  static propTypes = {
    name: PropTypes.string,
    dynamicFields: PropTypes.object,
    defaultValue: PropTypes.string,
    singleline: PropTypes.bool,
    processPreviewDynamicFields: PropTypes.func,
    processPreviewResults: PropTypes.func
  }

  static defaultProps = {
    dynamicFields: {}
  }

  state = {
    content: ''
  }

  componentWillMount() {
    this.setState({ content: this.props.defaultValue })
  }

  handleChange = content => this.setState({ content })

  render() {
    const { name, dynamicFields, defaultValue, singleline, processPreviewDynamicFields, processPreviewResults } = this.props
    const { content } = this.state

    return (
      <div className="rich-text-editor">
        <TextBlock
          singleline={singleline}
          defaultValue={defaultValue}
          dynamicFields={name === 'email_signature' ? Object.keys(dynamicFields) : Object.keys(dynamicFields).filter(key => key !== 'email_signature_image')}
          onChange={this.handleChange} />
        <TextBlockPreview
          html={content}
          dynamicFields={dynamicFields}
          processDynamicFields={processPreviewDynamicFields}
          processResults={processPreviewResults} />
        <input
          name={name}
          type="hidden"
          value={content}
          onChange={x => x} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Form/RichText/index.js